export default "<div style=\"height: 380px;\">\n  <nz-spin class=\"spinner spinner--centered\" nzSize=\"large\"></nz-spin>\n</div>\n\n";